import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Landing Page
import Landing from "./pages/Landing";

// Auth Pages
import Login          from "./pages/auth/Login";
import Register       from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";   // ← NEW
import ResetPassword  from "./pages/auth/ResetPassword";    // ← NEW

// Admin Pages
import AdminDashboard     from "./pages/admin/Dashboard";
import Users              from "./pages/admin/Users";
import AdminTrash         from "./pages/admin/AdminTrash";
import CarpenterLabours   from "./pages/admin/CarpenterLabours";

// Carpenter Pages
import CarpenterDashboard from "./pages/carpenter/Dashboard";
import LabourList         from "./pages/carpenter/LabourList";
import AddLabour          from "./pages/carpenter/AddLabour";
import Attendance         from "./pages/carpenter/Attendance";
import Payments           from "./pages/carpenter/Payments";
import Salary             from "./pages/carpenter/Salary";
import LabourAttendance   from "./pages/carpenter/LabourAttendance";
import InactiveLabours    from "./pages/carpenter/InactiveLabours";

// Labour Pages
import LabourDashboard from "./pages/labour/Dashboard";
import MyAttendance    from "./pages/labour/MyAttendance";
import MySalary        from "./pages/labour/MySalary";
import MyPayments      from "./pages/labour/MyPayments";
import LabourProfile   from "./pages/labour/Profile";

// Protected Route
import ProtectedRoute from "./components/common/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ================= LANDING ================= */}
        <Route path="/" element={<Landing />} />

        {/* ================= AUTH ================= */}
        <Route path="/login"                 element={<Login />} />
        <Route path="/register"              element={<Register />} />
        <Route path="/forgot-password"       element={<ForgotPassword />} />  {/* ← NEW */}
        <Route path="/reset-password/:token" element={<ResetPassword />} />   {/* ← NEW */}

        {/* ================= ADMIN ROUTES ================= */}
        <Route element={<ProtectedRoute role="admin" />}>
          <Route path="/admin/dashboard"         element={<AdminDashboard />} />
          <Route path="/admin/users"             element={<Users />} />
          <Route path="/admin/trash"             element={<AdminTrash />} />
          <Route path="/admin/carpenter-labours" element={<CarpenterLabours />} />
        </Route>

        {/* ================= CARPENTER ROUTES ================= */}
        <Route element={<ProtectedRoute role="carpenter" />}>
          <Route path="/carpenter/dashboard"                   element={<CarpenterDashboard />} />
          <Route path="/carpenter/labours"                     element={<LabourList />} />
          <Route path="/carpenter/add-labour"                  element={<AddLabour />} />
          <Route path="/carpenter/attendance"                  element={<Attendance />} />
          <Route path="/carpenter/payments"                    element={<Payments />} />
          <Route path="/carpenter/salary"                      element={<Salary />} />
          <Route path="/carpenter/labour-attendance/:labourId" element={<LabourAttendance />} />
          <Route path="/carpenter/inactive-labours"            element={<InactiveLabours />} />
        </Route>

        {/* ================= LABOUR ROUTES ================= */}
        <Route element={<ProtectedRoute role="labour" />}>
          <Route path="/labour/dashboard"  element={<LabourDashboard />} />
          <Route path="/labour/attendance" element={<MyAttendance />} />
          <Route path="/labour/salary"     element={<MySalary />} />
          <Route path="/labour/payments"   element={<MyPayments />} />
          <Route path="/labour/profile"    element={<LabourProfile />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
}